module.exports = __webpack_public_path__ + "assets/img/1401587607397_.pic_hd.1f27984d.jpg";